import React, { Component } from 'react'
import Toolbar from '@material-ui/core/Toolbar';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import Modal from '@material-ui/core/Modal'
import AddEditDining from "../../views/dinings/AddEditDining";
import { currentScrollingPage, itemPerPage } from "../../constants/index";
import Grid from '@material-ui/core/Grid';
import { Box, Button, Checkbox, IconButton, InputAdornment, Tab, Tabs, TextField } from "@material-ui/core";
import PropTypes from 'prop-types';
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Moment from 'moment';
import TrashAlt from '../../assets/svgs/solid/trash-alt';

import { SuperUserDropDown } from '../../components/SuperUserDropDown/SuperUserDropDown';

//Actions
import {
    GetAllDinings, DelDining, DeleteRecurrencyMeals, GetDiningFilters, BatchDeleteDining, DeleteAllDinings, GetDiningsForCSVExport
} from '../../actions/diningActions.js';
import { GetDiningLocations } from '../../actions/diningLocationActions'

import { getCommunityByIdAsync, getAllCommunities } from '../../actions/communityActions';
import { SetHeaderButtons } from '../../actions/headerButtonsActions';
import { CheckBox, CheckBoxOutlineBlank, Print } from '@material-ui/icons';
import PrintPreview from './PrintPreview';

//Views
import ModalDeleteMenuItem from './ModalDeleteMenuItem';
import DiningsFilters from './DiningsFilters';
import MultipleDeleteModal from './MultipleDeleteModal';


import {UpdateCurrentLocation} from '../../actions/currentUrlActions';
import { DELETE_DINING_SUCCESS, ADD_DINING_SUCCESS, UPDATE_DINING_SUCCESS, BATCH_DELETE_DINING_SUCCESS, DELETE_ALL_DINING_SUCCESS } from '../../constants/diningConstants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortAlphaDown, faSortAlphaUpAlt, faSortNumericDown, faSortNumericUpAlt, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import SwipeableViews from 'react-swipeable-views';

import DiningLocations from '../diningLocation/DiningLocations';
import AddEditDiningLocation from '../diningLocation/AddEditDiningLocation';


const initFilters={
    dateChanged:false,
    dateOptionSelected:'',
    startDate: new Date(),
    endDate: new Date(),
    mealsSelected:[],
    tagsSelected:[]
}

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};



export class Dining extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            openPrintPreview: false,
            tableData: [],
            isLoading: false,
            currentPage: currentScrollingPage,
            itemPerPage: itemPerPage,
            dining: undefined,
            //Community
            superUserCommunitySelected: undefined,
            superUserActivitiesLoaddedForCommunity: undefined,
            //RenderNedded
            renderNedded: undefined,
            openCommunityCombo: false,
            showModalDeleteMenuItem: false,
            recurrence: false,
            menuItemSelected: {},
            disableSaveBtn:false,

            searchValue:'',
            openSearch:false,

            filtersAnchorEl:null,
            filtersObj:{...initFilters, tagsSelected:[], mealsSelected:[]},
            filtersApplied:false,

            sortColumn:'dateStart',
            sortDesc:true,
            diningsSelected:[],
            openDeleteModal:false,
            selectAllButton:false,

            tab:0,
            openAddLocation:false,
            disableLocationSaveBtn:true,
            locationSelected:undefined
        };
        this.observer = React.createRef();
        this.lastMealRef = node => {
            /* FUNCION CALL BACK */
            if (this.observer.current) this.observer.current.disconnect();
            this.observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting) {
                    this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }));
                    this.getDining();
                }
            });
            if (node) this.observer.current.observe(node)
        }
    }

    componentDidMount() {
        document.title='Dinings'
        this.InitialLoading();
    };

    InitialLoading = () =>{
        
        if (!this.props.communityData || (this.props.communityData && this.props.communityData.length === 0))
            this.props.getAllCommunities();

        if (localStorage.getItem('superAdmin') === "false")
            this.getDining();

        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

        if (localStorage.getItem('communityId')) {

            this.GetCommunityDataByCommunityId(localStorage.getItem('communityId'));
            this.props.GetDiningLocations(localStorage.getItem('communityId'));

        }       

        this.SetHeaderButtons();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));

        this.props.SetHeaderButtons(undefined);
    };

    SetHeaderButtons = (open = false) => {
        const headerButtons = this.getHeaderButtons(open);
        this.props.SetHeaderButtons(headerButtons)
    };

    getHeaderButtons = (open = false) => {
        const communityIdExist = !!(localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0);
        const styles = {
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
            disabledDeleteButton: {
                backgroundColor: 'white'
            },
            disabledButton: {
                font: '24px',
                border: 'none',
                padding: '10px 15px',
                textAlign: 'center',
                textDecoration: 'none',
                display: 'inline-block',
                margin: '4px 3px',
                boxShadow: '0px 8px 16px #00000066',
                borderRadius: '50px',
                background: '#17d647 0% 0% no-repeat padding-box',
                float: 'right',
                backgroundColor: 'white',
                color: '#686868 ',
                pointerEvents: 'none',
            },
            skyBlueButton: {
                font: '24px',
                border: 'none',
                padding: '10px 15px',
                textAlign: 'center',
                textDecoration: 'none',
                display: 'inline-block',
                margin: '4px 3px',
                cursor: 'pointer',
                boxShadow: '0px 8px 16px #00000066',
                borderRadius: '50px',
                color: '#ffffff',
                background: '#17d647 0% 0% no-repeat padding-box',
                float: 'right',
                backgroundColor: '#009EDD',
            },
        }


        return (
            <Grid container style={styles.globalActions} >
                {
                    this.state.tab===0?
                    !open ?
                        <Grid item container justifyContent='flex-end' alignItems='center' style={styles.globalActions}>

                            <Grid style={{marginRight:"10px"}}
                                className={!communityIdExist ? "disableBottomButon appbtnBarButtonv2" : "appbtnBarButtonv2 blueButton"}
                                disabled={!communityIdExist}
                                id='export_dinings_btn'
                                onClick={this.ExportDiningsCommunityHandler}
                            >
    
                                Export to CSV

                            </Grid>
                            {
                                this.state.diningsSelected.length>0 &&
                                    <Grid
                                        id='delete_multiple_dinings'
                                        item
                                        className={!communityIdExist ? "disableBottomButon appbtnBarButton" : "appbtnBarButtonv2 redButton"}
                                        style={{ minWidth: '230px', marginRight:'1rem'}}
                                        disabled={!communityIdExist}
                                        onClick={()=>this.setState({openDeleteModal:true})} >
                                        {`Delete ${this.state.selectAllButton?this.props.tableData?.totalDinings : this.state.diningsSelected.length} Menu Items`}
                                    </Grid>
                            }
                            <Grid
                                id='dining_new_dining_btn'
                                item xs={7} sm={5} md={5} lg={3}
                                className={!communityIdExist ? "disableBottomButon appbtnBarButtonv2" : "appbtnBarButtonv2 blueButton"}
                                style={{ minWidth: '230px', maxWidth: '250px' }}
                                disabled={!communityIdExist}
                                onClick={this.addDining} >
                                Add Menu Item
                            </Grid>

                        </Grid>
                        :
                        <div className="appbtn-list-engage" style={styles.globalActions}>

                            <div id='add_dining_save_btn' className="blueBottomButon appbtnBarButton" onClick={this.SaveDining} 
                                style={{opacity:this.state.disableSaveBtn?'56%':'100%'}}
                            >
                                Save
                            </div>
                            {/* <div className="appbtn-engage redbtn-engage" onClick={this.CancelDining}>
                          Cancel
                      </div>                                                    */}
                            {
                                this.state.dining ?
                                    <div id='add_dining_delete_btn' className="appbtn-engage redbtn-engage appbtnBarButton" onClick={() => this.handleDeleteClick(undefined, this.state.dining)}>
                                        Delete
                                    </div>
                                    :
                                    undefined
                            }
                        </div>
                    :
                    this.state.openAddLocation?
                        <Grid item container justify='flex-end' alignItems='center' style={styles.globalActions}>
                            {
                                this.state.locationSelected ?
                                    <Grid id="Categories_delete_btn" className="appbtn-engage redbtn-engage appbtnBarButton" onClick={this.handleDeleteDiningLocation}>
                                        Delete
                                    </Grid>
                                    :
                                    <Grid id="Categories_cancel_btn" className="appbtn-engage graybtn-engage appbtnBarButton" onClick={this.cancelDiningLocation}>
                                        Cancel
                                    </Grid>
                            }

                            <Grid id="Categories_save_btn" className="appbtn-engage skybluebtn-engage appbtnBarButton"
                                style={{ opacity: this.state.disableLocationSaveBtn ? '56%' : '100%' }}
                                onClick={this.handleSaveDiningLocation}
                            >
                                Save
                            </Grid>

                        </Grid>
                    :
                    <Grid item container justify='flex-end' alignItems='center' style={styles.globalActions}>
                        <Grid
                            id='add_dining_location_btn'
                            item xs={7} sm={5} md={5} lg={4}
                            className={!communityIdExist ? "disableBottomButon appbtnBarButtonv2" : "appbtnBarButtonv2 blueButton"}
                            style={{ minWidth: '230px'}}
                            disabled={!communityIdExist}
                            onClick={this.handleOpenAddLocation}
                        >
                            Add Dining Location
                        </Grid>
                    </Grid>

                }
            </Grid>
        )
    }

    async GetCommunityDataByCommunityId(communityId, date) {
        let communityData = undefined;

        if (communityId) {
            communityData = await this.props.getCommunityByIdAsync(communityId);
            if (communityData[0].timeZoneName) {

                this.setState({ communityData: communityData });
                //provisionalDate =this.GetDateChangingTimeZone(provisionalDate, communityData[0].timeZoneName);
            }
        }
        return communityData[0];
    };

    getServeTime(diningItem, timeZoneName) {

        if ((!diningItem || diningItem.dateStart || diningItem.dateEnd) && timeZoneName) {

            const dateStartTimeZone = new Date(new Date(diningItem.dateStart).toLocaleString("en-US", { timeZone: timeZoneName }));
            return `${Moment(dateStartTimeZone).format("MMM D, YYYY")}`;
        }
        else {
            return ``;
        }
    };

    getDining = () => {
        if(this.state.filtersApplied){
            this.GetDiningWithFilters()
        }else{
            this.props.GetAllDinings(localStorage.getItem('communityId'), this.state.currentPage);            
        }

        if(this.state.selectAllButton){

            setTimeout(() => {
                this.SelectAllDiningsOnScrolling()
            }, 500);
        }
    };

    resize() {
        this.setState({ isMobile: window.innerWidth <= 970 });
    };

    OnCancelHandler = () => {
        this.setState({ showModalDeleteMenuItem: false });
    };

    OnDeleteHandler = () => {
        this.deleteDining({}, this.state.menuItemSelected);
        this.setState({ showModalDeleteMenuItem : false,  open: false, currentPage : 0});
        this.SetHeaderButtons(false);

    }

    OnDeleteRecurrenceHandler = () => {
        this.deleteRecurrencyMeals({}, this.state.menuItemSelected);
        this.setState({ showModalDeleteMenuItem : false, open: false, currentPage : 0 });
        this.SetHeaderButtons(false);
    }

    handleDeleteClick = async (e, data, index) => {
        if (e) {
            e.stopPropagation();
        }

        if (data) {
            this.setState({
                showModalDeleteMenuItem: true,
                menuItemSelected: data,
                recurrence: data.recurrencyData.endDateForRecurrency ? true : false
            });
        }
    };

    deleteDining = (event, item, isActive) => {
        if (item._id) {
            this.props.DelDining(item._id);
        }
    };

    deleteRecurrencyMeals = (event, item, isActive) => {

        if (item._id) {
            this.props.DeleteRecurrencyMeals(item._id);
        }
    };

    addDining = () => {
        this.setState({ open: true, dining: '' });
        this.SetHeaderButtons(true);
    };

    CancelDining = () => {
        var link = document.getElementById('cancel_btn');
        link.click();

        this.setState({disableSaveBtn:false})
        this.getDining()
    };

    SaveDining = () => {

        if(this.state.disableSaveBtn){
            return;
        }

        var link = document.getElementById('save_btn');
        link.click();
        this.getDining();
    };

    editDining = (e, item, index) => {

        this.setState({ dining: item, open: true, disableSaveBtn:true });

        setTimeout(() => {
            this.SetHeaderButtons(true);
        }, 200);
    };

    handleClose = (pageNextDining = 0) => {
        document.title='Dinings'

        this.setState({ open: false });
        this.SetHeaderButtons(false);

        if (pageNextDining > 0) {
            this.handlePageChange(pageNextDining);
        }

        this.getDining();
    };

    handlePageChange = (number) => {

        if (number && typeof (number) == 'number' && number > 0) {
            this.setState({
                currentPage: Number(number)
            });
        }

    };

    renderDiningType(type) {
        switch (type) {
            case 1:
                return "Breakfast";
            case 2:
                return "Lunch";
            case 3:
                return "Dinner";
            default:
                return "";
        }
    };

    GetCommunityObjectForSupuerUserCombo(communityId) {
        let communityObj = null;
        if (this.props.communityData) {

            communityObj = this.props.communityData.find(item => item.communityId === communityId);
        }

        return communityObj;
    };

    handleCommunityCombo = () => {
        this.setState((prevState) => ({ openCommunityCombo: !prevState.openCommunityCombo }));
    };

    handleCommunityOnBlur = () => {
        this.setState({ openCommunityCombo: false })
    };

    setIdsPaginationHandler = () => {
        try {
            const pagContainer = document.getElementsByClassName('MuiPagination-ul');
            if (pagContainer && pagContainer.length > 0 && pagContainer[0]) {
                const pag = pagContainer[0];
                const liElements = pag.getElementsByTagName('li');
                if (liElements && liElements.length >= 4) {
                    for (let i = 0; i < liElements.length; i++) {
                        liElements[i].removeAttribute('id')
                    }
                    const btn_GoToFist = liElements[0];
                    if (btn_GoToFist) {
                        btn_GoToFist.setAttribute('id', 'pag_btn_gotofirst');
                        btn_GoToFist.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_back = liElements[1];
                    if (btn_back) {
                        btn_back.setAttribute('id', 'pag_btn_goback');
                        btn_back.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_forward = liElements[liElements.length - 2];
                    if (btn_forward) {
                        btn_forward.setAttribute('id', 'pag_btn_goforward');
                        btn_forward.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }
                    const btn_GoToLast = liElements[liElements.length - 1];
                    if (btn_GoToLast) {
                        btn_GoToLast.setAttribute('id', 'pag_btn_gotolast');
                        btn_GoToLast.click(() => setTimeout(() => {
                            this.setIdsPaginationHandler();
                        }, 100)
                        )
                    }

                    for (let i = 2; i < liElements.length - 2; i++) {
                        const btn = liElements[i].getElementsByTagName('button');

                        if (btn && btn.length > 0 && btn[0] && btn[0].textContent.length > 0) {
                            liElements[i].setAttribute('id', `pagElement_${btn[0].textContent}`);
                        }
                    }
                }
            }
        } catch (err) { }
    };

    handleOpenPrintPreviewModal = () => {
        this.setState((prevState) => ({ openPrintPreview: !prevState.openPrintPreview }))
    };

    localStorageRemoveItem = (key) => {
        try {
            if (key) {
                localStorage.removeItem(key);
            }

        } catch (err) { }
    };

    localStorageSetItem = (key, value) => {
        try {
            if (key && value) {
                localStorage.setItem(key, value);
            }


            if (value && value.length > 0) {
                this.setState({
                    filtersObj:{...initFilters, mealsSelected:[], tagsSelected:[]},
                    sortColumn:'dateStart',
                    sortDesc:true,
                    filtersApplied:false,
                    searchValue:'',
                    openSearch:false,
                    currentPage:0
                })

                this.props.GetAllDinings(value, this.state.currentPage);

            }
        } catch (err) { }
    };

    setLocalState = (objectToSet) => {
        try {
            this.setState({ ...objectToSet, selectAllButton:false, diningsSelected:[] }, ()=>this.SetHeaderButtons(false))
        } catch (err) { }
    };


    ThumbnailImage = (
        {
            height = '70px',
            width = '110px',
            alt,
            url
        }
    ) => {
        return (
            <img
                alt={'Thumbnail ' + alt}
                style={{ borderRadius: '10px', alignContent: 'center', objectFit:'cover' }}
                width={width}
                height={height}
                src={url}
            >
            </img>
        );
    };

    enableSaveButton=()=>{

        this.setState({disableSaveBtn:false}, ()=>this.SetHeaderButtons(true));
    }

    disableSaveButton=()=>{
        this.setState({disableSaveBtn:true}, ()=>this.SetHeaderButtons(true))

    }

    GetDiningWithFilters = ()=>{

        const commId = localStorage.getItem('communityId');

        this.props.GetDiningFilters(commId, this.state.currentPage, this.state.filtersObj, this.state.searchValue, this.state.sortColumn, this.state.sortDesc);

        if(this.state.selectAllButton){
            setTimeout(() => {
                this.SelectAllDiningsOnScrolling()
            }, 500);
        }
    }

    applyFilters=(filters)=>{
        this.setState({
            filtersObj:filters, 
            currentPage:0, 
            filtersApplied:true, 
            filtersAnchorEl:null,
            selectAllButton:false, 
            diningsSelected:[]
        },()=>{
            this.GetDiningWithFilters()
            this.SetHeaderButtons(false)
        });
    }

    resetFilters=()=>{
        if(this.state.searchValue!=='' || this.state.sortColumn!=='dateStart'|| this.state.sortDesc!==true){
            this.setState({
                filtersObj:{...initFilters, mealsSelected:[], tagsSelected:[]}, 
                currentPage:0,
                selectAllButton:false,
                diningsSelected:[]
            },()=>{this.GetDiningWithFilters(); this.SetHeaderButtons(false)})

        }else{
            this.setState({
                filtersObj:{...initFilters, mealsSelected:[], tagsSelected:[]}, 
                currentPage:0, 
                filtersApplied:false,
                selectAllButton:false,
                diningsSelected:[]
            },()=>{
                this.props.GetAllDinings(localStorage.getItem('communityId'), this.state.currentPage)
                this.SetHeaderButtons(false)
            })
        }

    }

    handleSearch=()=>{
        this.setState({filtersApplied:true, currentPage: 0, selectAllButton:false, diningsSelected:[]},()=>{this.GetDiningWithFilters(); this.SetHeaderButtons(false)});
    }

    handleResetSearch =()=>{
        this.setState({searchValue:'', openSearch:false, currentPage:0, selectAllButton:false, diningsSelected:[]},()=>{this.GetDiningWithFilters(); this.SetHeaderButtons(false)})
    }

    handleSort=(column)=>{

        const currentColumn = this.state.sortColumn;

        const updState={
            sortColumn: currentColumn,
            sortDesc: this.state.sortDesc,
            currentPage:0,
            filtersApplied:true
        }

        switch (column) {
            case 'lowerName':
                if(currentColumn !==column){
                    updState.sortColumn = 'lowerName'
                    updState.sortDesc = true;
                }else{
                    updState.sortDesc = !this.state.sortDesc 
                }
                break;
            case 'dateStart':
                if(currentColumn !==column){
                    updState.sortColumn = 'dateStart'
                    updState.sortDesc = true;
                }else{
                    updState.sortDesc = !this.state.sortDesc 
                }
                break;
            case 'meal':
                if(currentColumn !==column){
                    updState.sortColumn = 'meal'
                    updState.sortDesc = true;
                }else{
                    updState.sortDesc = !this.state.sortDesc 
                }
                break;
            default:
                break;
        }

        this.setState(updState, ()=>this.GetDiningWithFilters())

    }

    handleSelectMeal=(dining)=>{

        //Get the dinings already selected
        const arr = this.state.diningsSelected;

        //Know if the dining is already in the array
        const item = arr.find(item =>item._id===dining._id);

        let button = false

        //If its not we push the dining
        if (!item) {
            arr.push(dining)

            if(arr.length===this.props.tableData.data.length) button=true

        }
        else { //If it is we remove it from the array
            const indexToDelete = arr.findIndex(object =>(object._id === dining._id));
            arr.splice(indexToDelete, 1);
        }

        this.setState({ diningsSelected: arr, selectAllButton:button }, ()=>this.SetHeaderButtons(false));
    }

    handleSelectAll = (e) => {
        const selectAllButton = !this.state.selectAllButton;
        let selected = this.state.diningsSelected

        const allDinings = this.props.tableData ? this.props.tableData.data : [];

        if (allDinings.length > 0){
   
            if (selectAllButton) {
                allDinings.forEach(item => {
                    const exist = this.state.diningsSelected.find(d => d._id===item._id);
                    (!exist) && selected.push(item);
                    
                });
            }
            else {
                selected = [];
                
            }
        }
        
        this.setState({ diningsSelected: selected, selectAllButton: selectAllButton }, () => this.SetHeaderButtons(false));
    };

    SelectAllDiningsOnScrolling = () => {
        const allDinings = this.props.tableData ? this.props.tableData.data : [];
        let selected = this.state.diningsSelected 

        if (allDinings.length > 0) //First we add all the new data into the selected arr
            allDinings.forEach(item => {
                const exist = this.state.diningsSelected.find(d => d._id===item._id);
                
                (!exist) && selected.push(item);
            });

            //Now we filter because it could be dinings that migth not be in the new filtered data
            selected = selected.filter(d => {
                return allDinings.find(element => (element._id === d._id));
            })


        this.setState({ diningsSelected: selected }, ()=>this.SetHeaderButtons(false));
    }

    handleBatchDelete=async()=>{
        if(this.state.selectAllButton){
            const id = localStorage.getItem('communityId')
            this.props.DeleteAllDinings(id, this.state.filtersObj, this.state.searchValue);

        }else{

            const diningsToDelete = this.state.diningsSelected.map(i=>(i._id));
            this.props.BatchDeleteDining(diningsToDelete)

        }
        this.setState({openDeleteModal:false, diningsSelected:[], selectAllButton:false}, ()=>this.SetHeaderButtons(false))


    }

    a11yProps = (index) => {
        return {
            id: `boards-tab-${index}`,
            'aria-controls': `boards-tabpanel-${index}`,
        };
    };


    handleTabChange = (event, newValue) => {
        this.handleChangeIndex(newValue);
    };


    handleChangeIndex = (index) => {

        this.setState({
            tab: index
        }, ()=>{
            (index===0)?
            this.getDining()
            :
            this.props.GetDiningLocations(localStorage.getItem('communityId'))

            
            this.SetHeaderButtons(false)
        });
    };

    enableSaveLocation = () => {

        this.setState({ disableLocationSaveBtn: false }, () => this.SetHeaderButtons(false, 1))
    }

    disableSaveLocation = () => {
        this.setState({ disableLocationSaveBtn: true }, () => this.SetHeaderButtons(false, 1))
    }


    cancelDiningLocation = () => {
        this.setState({ openAddLocation: false, locationSelected:undefined }, () => this.SetHeaderButtons(this.state.open, this.state.tab))
    }

    handleSaveDiningLocation = () => {

        if (this.state.disableLocationSaveBtn) {
            return;
        }

        const link = document.getElementById('save_dining_location_btn');

        if (link) {
            link.click();
        }
    }

    handleOpenAddLocation = () => {
        this.setState({ openAddLocation: true, disableLocationSaveBtn: true }, () => this.SetHeaderButtons(false, this.state.tab ))
    }

    handleSelectDiningLocation = (location) => {
        this.setState({ locationSelected: location, openAddLocation: true, disableLocationSaveBtn: true }, () => this.SetHeaderButtons(this.state.open, this.state.tab))
    }

    handleDeleteDiningLocation = () => {

        const link = document.getElementById('delete_dining_location_btn');

        if (link) {
            link.click();
        }

    }


    ExportDiningsCommunityHandler = () =>{
        try{
            const communityId = localStorage.getItem('communityId')? localStorage.getItem('communityId') : undefined;

            const communityFound = (this.props.communityData && this.props.communityData.length > 0)?this.props.communityData.find(a => String(a.communityId) === String(communityId)): undefined;
            if(communityId){
                const communityName= (communityFound && communityFound.name)? communityFound.name: ''
                this.props.GetDiningsForCSVExport(communityId, communityName)
            }
        }catch(err){
            return undefined
            
        }
    }

    render() {

        const shouldReturnToHome = (this.props.returnToHome && this.props.returnToHome ==='true')? true: false;
        if(this.props.UpdateCurrentLocation && shouldReturnToHome){

            this.setState(
                {
                    open: false
                },
                () =>{
                this.InitialLoading();
                this.props.UpdateCurrentLocation('false');
            })
        }
    
        //Set IDS PAGINATION
        setTimeout(() => {
            this.setIdsPaginationHandler();
        }, 100);

        if (this.props.diningReducerType === DELETE_DINING_SUCCESS || this.props.diningReducerType === ADD_DINING_SUCCESS || this.props.diningReducerType === UPDATE_DINING_SUCCESS
            || this.props.diningReducerType === BATCH_DELETE_DINING_SUCCESS || this.props.diningReducerType === DELETE_ALL_DINING_SUCCESS
            ){
            this.setState({currentPage:0},()=>this.getDining()) 
        }

        const diningObject = (this.props.location && this.props.location.state && this.props.location.state.diningObject) ? this.props.location.state.diningObject : undefined;

        if (this.state.dining === undefined && this.state.open === false && diningObject) {
            this.setState({ open: true, dining: diningObject }, () => this.SetHeaderButtons(true));
        }


        if ((!this.state.renderNedded) && this.state.communityData) {
            this.setState({ renderNedded: true });
        }

        const isSuperAdmin = localStorage.getItem('superAdmin') ? (localStorage.getItem('superAdmin') === "true") : false;

        if (isSuperAdmin
            && this.props.communityData
            && this.props.communityData.length > 0
            && localStorage.getItem('communityId')
            && localStorage.getItem('communityId').length > 0
            && this.state.superUserCommunitySelected === undefined
        ) {
            this.setState({ superUserCommunitySelected: this.GetCommunityObjectForSupuerUserCombo(localStorage.getItem('communityId')) });
        }

        if (
            (
                this.state.superUserCommunitySelected &&
                (
                    !this.state.superUserActivitiesLoaddedForCommunity ||
                    (this.state.superUserActivitiesLoaddedForCommunity !== this.state.superUserCommunitySelected)
                )
            ) ||
            (
                this.state.superUserCommunitySelected === undefined &&
                this.state.superUserActivitiesLoaddedForCommunity !== undefined
            )
        ) {
            this.getDining();
            this.props.GetDiningLocations(localStorage.getItem('communityId'))
            this.setState({ superUserActivitiesLoaddedForCommunity: this.state.superUserCommunitySelected });
        }

        const currentPage = this.state.currentPage;
        const itemPerPage = this.state.itemPerPage;

        const currentData = this.props.tableData ? this.props.tableData.data : [];

        const totalDinings = this.props.tableData ? this.props.tableData.totalDinings : 0;
        const totalLocations = this.props.locationData ? this.props.locationData.length : 0

        const lastPage = Math.ceil(totalDinings / itemPerPage);
        const pageNextDining = totalDinings % itemPerPage === 0 ? lastPage + 1 : lastPage;
        const displayHeaders = this.state.isMobile ? 'none' : 'flex';

        const disabledButton = false;

        //Objeto que contiene los estilos declarados por useStyles
        const styles = {
            title: {
                flexGrow: 1
            },
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            }
        }

        return (
            <Grid item container xs={12}>
                <AppBar position="static" className="dark">
                    <Toolbar>
                        <Grid item container xs={!this.state.open ? 4 : 12} sm={6} md={6} lg={6} alignContent='center' justify='flex-start'>
                            {
                                this.state.open ?
                                    <Typography variant="h6"  >
                                        <div id='add_dining_return_btn' className="engage-nav ToolbalCommunityName" onClick={this.CancelDining}>
                                            <img
                                                src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                alt='return'
                                                className="returnIcon"
                                            />
                                            {
                                                (this.state.superUserCommunitySelected && this.state.superUserCommunitySelected.name) ? this.state.superUserCommunitySelected.name + ' Meals' : 'Meals'
                                            }
                                        </div>
                                    </Typography>
                                    :
                                this.state.openAddLocation?
                                    <Typography variant="h6"  >
                                        <div id='Dining_Location_back_btn' className="engage-nav ToolbalCommunityName" onClick={() => this.setState({ openAddLocation: false, locationSelected: undefined }, () => this.SetHeaderButtons(false, this.state.tab))}>
                                            <img
                                                src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                alt='return'
                                                className="returnIcon"
                                            />
                                            All Dining Locations
                                        </div>
                                    </Typography>
                                :      
                                    <span id='dining_view_title' className="titleAppBar ToolbalCommunityName">
                                        Dining
                                    </span>
                            }
                        </Grid>

                        <Grid container xs={!this.state.open ? 12 : 1} sm={6} md={6} lg={6} style={styles.globalActions} >
                            {

                                !this.state.open && !this.state.openAddLocation ?
                                    <Grid xs={12} item container justify='flex-end' alignContent='center' style={styles.globalActions}>
                                        {
                                            (isSuperAdmin && isSuperAdmin === true) ?
                                                <Grid item container xs={10} style={{ paddingLeft: '15px' }} justify='center' alignContent='center' >
                                                    <SuperUserDropDown
                                                        stateOpen={this.state.open}
                                                        localStorageSetItem={this.localStorageSetItem}
                                                        localStorageRemoveItem={this.localStorageRemoveItem}
                                                        SetHeaderButtons={this.SetHeaderButtons}
                                                        handleCommunityCombo={this.handleCommunityCombo}
                                                        setState={this.setLocalState}
                                                        communityData={this.props.communityData}
                                                        superUserCommunitySelected={this.state.superUserCommunitySelected}
                                                        openCommunityCombo={this.state.openCommunityCombo}
                                                        handleCommunityOnBlur={this.handleCommunityOnBlur}
                                                    />
                                                </Grid>
                                                :
                                                undefined

                                        }
                                        {
                                            this.state.tab===0&&
                                            <Grid item container xs={2}>
                                                <IconButton id="dining_print_icon" onClick={this.handleOpenPrintPreviewModal}>
                                                    <Print style={{ fontSize: 40, color: '#9c9b9c' }} />
                                                </IconButton>
                                            </Grid>
                                        }
                                      

                                        {/* <Grid 
                                    item  xs={2} 
                                    //style={!communityIdExist ? styles.disabledButton: styles.skyBlueButton}
                                    className={!communityIdExist ? "disableBottomButon": "blueBottomButon"}
                                    disabled={!communityIdExist}
                                    onClick={this.addDining} >
                                    New Dining
                                </Grid>  */}
                                    </Grid>
                                    :
                                    undefined
                            }
                        </Grid>
                    </Toolbar>
                </AppBar>
                <main style={{width:'100%'}}>
                    <div >
                        {
                            this.state.open ?
                                <div className="content-engage-dining" style={{paddingTop:'15px'}}>
                                <AddEditDining 
                                    images={this.props.diningImages} 
                                    closeDialog={this.handleClose} 
                                    data={this.state.dining} 
                                    newItemPage={pageNextDining} 
                                    currentPage={currentPage} 
                                    isSaveDisabled={this.state.disableSaveBtn}
                                    enableBtn={this.enableSaveButton}
                                    disableBtn={this.disableSaveButton}
                                    timeZone={this.state.communityData ? this.state.communityData[0].timeZoneName : undefined}
                                /> 
                                </div>
                            : this.state.openAddLocation?
                                <AddEditDiningLocation
                                    close={this.cancelDiningLocation}
                                    data={this.state.locationSelected}
                                    enableButton={this.enableSaveLocation}
                                    disableButton={this.disableSaveLocation}
                                    buttonState={this.state.disableLocationSaveBtn}
                                />
                                :
                            <>
                                <Tabs
                                    value={this.state.tab}
                                    onChange={this.handleTabChange}
                                    TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                    variant="fullWidth"
                                    aria-label="full width tabs Dining"
                                    style={{ width: '100%', backgroundColor: '#1f1f1f' }}
                                >
                                    <Tab label={`Menu Items (${totalDinings})`} className={(this.state.tab === 0) ? "SelectedTabStyle" : "tabStyle"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                                    <Tab label={`Dining Locations (${totalLocations})`} className={(this.state.tab === 1) ? "SelectedTabStyle" : "tabStyle"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                                </Tabs>

                                <Grid item container xs={12}>
                                    <SwipeableViews
                                        axis={'x'}
                                        index={this.state.tab}
                                        onChangeIndex={this.handleChangeIndex}
                                        className="swipeableViews"
                                    >
                                        <TabPanel value={0} index={0} dir={'x'}>
                                            {/* Dining List */}
                                            <Grid container className="activityTitle-engage">

                                                {/* Selected All Button and selected item counter */}
                                                <Grid item container xs={4} justifyContent='flex-start' alignItems='center'>
                                                    <Button id='addEditDevice_Headers_SelectAll' className="selectAllButtonv2" onClick={() => this.handleSelectAll()}>
                                                        Select All
                                                    </Button>
                                                    <span className="selectAllQtyMessagev2" style={{marginLeft: '16px'}}>
                                                    {
                                                        this.state.selectAllButton?
                                                        `${totalDinings} Selected`:
                                                        this.state.diningsSelected.length > 0 ?
                                                        `${this.state.diningsSelected.length} Selected`
                                                        :
                                                        ''
                                                    }
                                                    </span>
                                                </Grid>
                                                {/* Search and filters menu */}
                                                <Grid item container xs={8} justifyContent='flex-end' alignItems='center'>
                                                    {
                                                        this.state.openSearch?
                                                            <Grid item container xs={10} sm={10} md={6} lg={4} style={{marginBottom:'1rem'}}>
                                                                <TextField
                                                                    id='dining_search'
                                                                    item 
                                                                    name='Search'
                                                                    placeholder= "Enter search term(s) and press Enter"
                                                                    value={this.state.searchValue}
                                                                    fullWidth
                                                                    InputProps={{
                                                                    disableUnderline:true,
                                                                    startAdornment:(
                                                                        <InputAdornment position="start">
                                                                            <img
                                                                                src='https://engage360.s3.amazonaws.com/Icons/Categories/search.svg'
                                                                                alt='search_icon'
                                                                                width='32px'
                                                                                heigth='32px'
                                                                            />
                                                                        </InputAdornment>
                                                                    ),
                                                                    endAdornment:(
                                                                        <InputAdornment position="end">
                                                                                <IconButton id='dinings_clear_btn' onClick={()=>this.handleResetSearch()}>
                                                                                    <FontAwesomeIcon icon={faTimesCircle} color='white' size='sm' />
                                                                                </IconButton>
                                                                            </InputAdornment>  
                                                                            )}}
                                                                    className="activities_search animate__animated animate__slideInRight"
                                                                    onChange={(e)=>this.setState({searchValue:e.target.value})}
                                                                    onKeyDown={(e)=>{if(e && e.keyCode===13) this.handleSearch()}}
                                                                />

                                                            </Grid>
                                                            :
                                                            <IconButton item onClick={()=>this.setState({openSearch:true})} id='search_btn'>
                                                                <img
                                                                    src='https://engage360.s3.amazonaws.com/Icons/Categories/search.svg'
                                                                    alt='search_icon'
                                                                    width='30px'
                                                                    heigth='30px'
                                                                />
                                                            </IconButton>

                                                        }

                                                        <IconButton item onClick={(e)=>this.setState({filtersAnchorEl:e.currentTarget})} id='filters_btn'>
                                                            <img
                                                                src='https://engage360.s3.amazonaws.com/Icons/Categories/filter.svg'
                                                                alt='filters_icon'
                                                                width='30px'
                                                                heigth='30px'
                                                            />
                                                        </IconButton>

                                                    </Grid>

                                                <Grid container className="titleActivityStyleHeaders" style={{ display: displayHeaders }} justify='center' alignItems='center' >
                                                    <Grid id="id_dining_header_ckeckbox" item xs={1}></Grid>
                                                    <Grid id="id_dining_header_list_image" item md={2} style={{ textAlign: 'center' }} >Image</Grid>
                                                    <Grid id="id_dining_header_list_menu_item" item md={4}>
                                                        Menu Item
                                                        <IconButton onClick={()=>this.handleSort('lowerName')}>
                                                            <FontAwesomeIcon icon={(this.state.sortColumn==='lowerName' && this.state.sortDesc)? faSortAlphaDown : (this.state.sortColumn==='lowerName' && !this.state.sortDesc)? faSortAlphaUpAlt : (this.state.sortColumn!=='lowerName')? faSort :null} color='#a2a1a2' />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid id="id_dining_header_list_meal" item md={2}>
                                                        Meal
                                                        <IconButton onClick={()=>this.handleSort('meal')}>
                                                            <FontAwesomeIcon icon={(this.state.sortColumn==='meal' && this.state.sortDesc)? faSortAlphaDown : (this.state.sortColumn==='meal' && !this.state.sortDesc)? faSortAlphaUpAlt : (this.state.sortColumn!=='meal')? faSort :null} color='#a2a1a2' />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid id="id_dining_header_list_date_serve" item md={2}>
                                                        Date Served
                                                        <IconButton onClick={()=>this.handleSort('dateStart')}>
                                                            <FontAwesomeIcon icon={(this.state.sortColumn==='dateStart' && this.state.sortDesc)? faSortNumericDown : (this.state.sortColumn==='dateStart' && !this.state.sortDesc)? faSortNumericUpAlt : (this.state.sortColumn!=='dateStart')? faSort :null} color='#a2a1a2' />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid id="id_dining_header_list_delete" item md={1}></Grid>
                                                </Grid>
                                                <Grid container>
                                                    {currentData && currentData.map((dining, index) => {

                                                        return (
                                                            <Grid ref={(currentData.length === index + 1)? this.lastMealRef:undefined} container xs={12} key={index} justify='center' alignItems='center' className="rowEngageStyleList"
                                                                id={`dining_row_${dining._id}`}
                                                                onClick={(e) => {
                                                                    this.editDining(e, dining);
                                                            }}>
                                                                {/* Checkbox to selec the item */}
                                                                <Grid item container justifyContent='center' xs={1}  onClick={(e) => e.stopPropagation()}> 
                                                                    <Checkbox
                                                                        checked={this.state.diningsSelected.find(i=>i._id===dining._id)?true:false}
                                                                        onChange={(e) => this.handleSelectMeal(dining) }
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        icon={<CheckBoxOutlineBlank fontSize='large'/>}
                                                                        checkedIcon={<CheckBox fontSize='large' style={{color:'#009EDD'}}/>}
                                                                        id={`dining_checkbox_${dining._id}`}
                                                                    />
                                                                </Grid>
                                                                <Grid item container justifyContent='center' alignItems='center' xs={12} sm={12} md={2}>
                                                                    <this.ThumbnailImage alt={index} url={dining.imageUrl ? dining.imageUrl : ''} />
                                                                </Grid>
                                                                <Grid item xs={12} sm={12} md={4} className="rowEngageStyle rowEngageStyleLeft" >{dining.name}</Grid>
                                                                <Grid item xs={12} sm={12} md={2} className="rowEngageStyle rowEngageStyleLeft" >{this.renderDiningType(dining.type)}</Grid>
                                                                <Grid item xs={12} sm={12} md={2} className="rowEngageStyle rowEngageStyleLeft" >{this.getServeTime(dining, this.state.communityData ? this.state.communityData[0].timeZoneName : undefined)}</Grid>
                                                                <Grid item xs={12} sm={12} md={1} className='EngageButonClass' style={{ alignContent: 'flex-end', display: 'flex', justifyContent: 'flex-end' }}>
                                                                    <Button
                                                                        id={`delete_btn_dining_row_${dining._id}`}
                                                                        variant="text"
                                                                        value={dining._id}
                                                                        color='secondary'
                                                                        className="transparentButtom"
                                                                        disabled={disabledButton}
                                                                        onClick={(e) => {
                                                                            this.handleDeleteClick(e, dining);
                                                                        }}
                                                                    >
                                                                        <TrashAlt className="iconDeleteListIcon" />
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                        )

                                                    }
                                                    )}

                                                </Grid>
                                                {
                                                    this.state.openPrintPreview &&
                                                    <PrintPreview
                                                        onClose={this.handleOpenPrintPreviewModal}
                                                    />
                                                }
                                            </Grid>
                                        </TabPanel>


                                        <TabPanel value={1} index={1} dir={'x'}>
                                            <Grid item container xs={12}>
                                                <DiningLocations
                                                    onSelectLocation={this.handleSelectDiningLocation}
                                                />
                                            </Grid>
                                           
                                        </TabPanel>



                                    </SwipeableViews>

                                </Grid>
                                
                               
                            </>
                             
                        }
                    </div>
                    <Modal
                        open={this.state.showModalDeleteMenuItem}
                        onClose={() => this.setState({ showModalDeleteMenuItem: false })}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ borderRadius: '16px' }}
                    >
                        <ModalDeleteMenuItem
                            menuItem={this.state.menuItemSelected ? this.state.menuItemSelected : {}}
                            timeZoneName={this.state.communityData ? this.state.communityData[0].timeZoneName : undefined}
                            OnCancelHandler={this.OnCancelHandler}
                            OnDeleteHandler={this.OnDeleteHandler}
                            OnDeleteRecurrenceHandler={this.OnDeleteRecurrenceHandler}
                            recurrence={this.state.recurrence}
                        />
                    </Modal>
                    <Modal
                        open={this.state.openDeleteModal && this.state.diningsSelected.length>0?true:false}
                        onClose={() => this.setState({ openDeleteModal: false })}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ borderRadius: '16px' }}
                    >
                        <MultipleDeleteModal
                            dinings={this.state.diningsSelected}
                            timeZoneName={this.state.communityData ? this.state.communityData[0].timeZoneName : undefined}
                            getMealType={this.renderDiningType}
                            getTime={this.getServeTime}
                            close={()=>this.setState({openDeleteModal:false})}
                            delete={this.handleBatchDelete}
                            selectAll={this.state.selectAllButton}
                            totalDinings={this.props.tableData?.totalDinings?this.props.tableData.totalDinings:0}
                        />
                    </Modal>
                    {
                           this.state.filtersAnchorEl &&
                           <DiningsFilters
                               anchorEl={this.state.filtersAnchorEl}
                               onClose={() => this.setState({ filtersAnchorEl: null })}
                               filters = {this.state.filtersObj}
                               applyFilters = {this.applyFilters}
                               resetFilters = {this.resetFilters}
                           />
                    }
                </main>
            </Grid>
        )
    }
}

function mapStateToProps(state, dispatch) {

    const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;
    let communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId, timeZoneName: item.timeZoneName })) : [];
    const currentCommunity = (communityId) ? communityData.find(item => item.communityId === communityId) : undefined;
    let diningData = (state.diningReducer && state.diningReducer.diningData) ? state.diningReducer.diningData : [];
    let imagesData = (state.diningReducer && state.diningReducer.diningImages) ? state.diningReducer.diningImages : [];
    let returnToHome = (state && state.currentUrlReducer && state.currentUrlReducer.returnToHome)? state.currentUrlReducer.returnToHome :  'false';
    const locationData = (state.diningLocationReducer?.diningLocationData) ? state.diningLocationReducer.diningLocationData : [];


    if (diningData && diningData.data) {

        diningData.data = currentCommunity ?
            (diningData.data.map(item => {

                return {
                    ...item,
                    dateStart: (item.dateStart && typeof item.dateStart === 'string') ? (item.dateStart ? new Date(new Date(item.dateStart).toLocaleString("en-US", { timeZone: currentCommunity.timeZoneName })) : new Date()) : item.dateStart,
                    dateEnd: (item.dateEnd && typeof item.dateEnd === 'string') ? (item.dateStart ? new Date(new Date(item.dateEnd).toLocaleString("en-US", { timeZone: currentCommunity.timeZoneName })) : new Date()) : item.dateEnd,
                    recurrencyData:
                    {
                        ...item.recurrencyData,
                        endDateForRecurrency: (item.recurrencyData && item.recurrencyData.endDateForRecurrency && typeof item.recurrencyData.endDateForRecurrency === 'string') ? (item.recurrencyData && item.recurrencyData.endDateForRecurrency ? new Date(new Date(item.recurrencyData.endDateForRecurrency).toLocaleString("en-US", { timeZone: currentCommunity.timeZoneName })) : new Date()) : item.recurrencyData.endDateForRecurrency
                    }
                }
            }
            )) :
            diningData;
    }


    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }

    return {
        tableData: diningData,
        communityData: communityData,
        diningImages: imagesData,
        diningReducerType : (state.diningReducer && state.diningReducer.type) ? state.diningReducer.type : "",
        returnToHome:returnToHome,
        locationData
    }
}

Dining = reduxForm({
    form: 'DeviceForm',
    // validate,
    enableReinitialize: true,
})(Dining);

export default connect(mapStateToProps,
    {
        GetAllDinings,
        DelDining,
        getCommunityByIdAsync,
        SetHeaderButtons,
        getAllCommunities,
        DeleteRecurrencyMeals,
        UpdateCurrentLocation,
        GetDiningFilters,
        BatchDeleteDining,
        DeleteAllDinings,
        GetDiningLocations,
        GetDiningsForCSVExport
        //, GetDiningDetails
    })(Dining);
